<template>
  <div
    :class="{'csu-clickable': clickable}"
    :style="containerStyle"
    @click="handleClickEvent()"
    @mouseenter="handleEvent('hover')"
  >
    <template v-if="isShowInnerSlot">
      <div :style="innerSlotWidthHeight">
        <slot></slot>
      </div>
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
export default {
  name: 'CContainer',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'container-',
    };
  },
  computed: {
    // 合并背景图样式
    containerStyle() {
      const mergedStyle = {
        ...this.styles.base,
        backgroundImage: `url(${this.configurationData?.backgroundImg || ''})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto 100%',
      };
      if (!this.$isInEditor && parseInt(this.styles.inner.width, 10) > parseInt(this.styles.base.width, 10)) {
        mergedStyle.overflowX = 'auto';
        mergedStyle.overflowY = 'hidden';
      }
      return mergedStyle;
    },
    // rem 转 px的时候 实际乘数
    multiplier() {
      let baseWidth = 750;
      if (this.deviceMode === 'h5-h') {
        baseWidth = 1334;
      }
      return 100 * (window.screen.width / baseWidth);
    },
    innerSlotWidthHeight() {
      if (parseInt(this.styles.inner?.width || 0, 10) > parseInt(this.styles.base.width, 10)) {
        return {
          width: this.styles.inner?.width || 0,
          height: this.styles.base.height,
        };
      }
      return {};
    },
    isShowInnerSlot() {
      return parseInt(this.styles.inner?.width || 0, 10) > parseInt(this.styles.base.width, 10);
    },
  },
  created() {
    console.info('created styles', this.styles);
  },
  methods: {
    getInnerSlotStyle() {
      // 针对通用容器的影子宽度做计算,内部大于外部时才撑宽
      const shadowStyle = this.styles.base;
      if (parseInt(this.styles.inner?.width || 0, 10) > parseInt(this.styles.base.width, 10)) {
        shadowStyle.width = this.styles.inner?.width || 0;
      }
      return shadowStyle;
    },
  },
};
</script>
<style lang="scss">

</style>
